'use client'

import { useEffect } from 'react'
import { useSearchParams, useRouter } from 'next/navigation'
import { toast } from 'sonner'
import posthog from 'posthog-js'

export function PaymentStatusHandler() {
  const searchParams = useSearchParams()
  const router = useRouter()

  useEffect(() => {
    const canceled = searchParams.get('canceled')
    if (canceled === 'true') {
      posthog.capture('subscription_payment_cancelled')
      toast.error('Payment was canceled. You can try again anytime.')
      const url = new URL(window.location.href)
      url.searchParams.delete('canceled')
      router.replace(url.toString(), { scroll: false })
    }
  }, [searchParams, router])

  return null
}
